export default {
  lim_limits: 'Limits',
  lim_limits_requests: 'Request list',
  lim_imposed_on: 'Imposed on',
  lim_one_time: 'One time limit',
  lim_daily: 'Daily limit',
  lim_weekly: 'Weekly limit',
  lim_monthly: 'Monthly limit',
  lim_annual: 'Annual limit',
  lim_left_total: '(Used/total)',
  lim_upload_poi: 'Upload proof of income',
  lim_poi: 'Proof of income',
  lim_requested: 'Request successfully sent',
  lim_date: 'Date',
  lim_request_id: 'Request ID',
  lim_state: 'State',
  lim_asset: 'Asset',
  lim_proof: 'Proof of income',
  lim_heading: 'Limits imposed on account',
  lim_left: 'left',
  lim_total: 'total',
  lim_spent: 'spent',
  lim_change_limits: 'Change limits',
  lim_change_limits_title: 'Change limits - %{assetName} (%{asset})',
  lim_no_changing_requests: 'No limits changing requests',
  lim_no_changing_requests_desc: 'Here will be the list of your limits changing request',
  lim_transaction_type_title: 'Transaction type',
  lim_requirements_title: 'Requirements',
  lim_pending_request_msg: 'Your request is pending review by the administrator',
  lim_upload_documents_btn: 'Upload documents',
  lim_operation_type_limit_label: 'Operation type limit',
  limit_daily_validation_msg: 'Please, set daily out limit',
  limit_weekly_validation_msg: 'Please, set weekly out limit',
  limit_monthly_validation_msg: 'Please, set monthly out limit',
  limit_validation_msg: 'Please, set limits',
  lim_daily_left: 'Daily limit left:',
  lim_weekly_left: 'Weekly limit left:',
  lim_monthly_left: 'Monthly limit left:',
  lim_annual_left: 'Annual limit left:',
  limit_daily_fall_behind_msg: 'Daily limit can\'t fall behind 0',
  limit_weekly_fall_behind_msg: 'Weekly limit can\'t fall behind 0',
  limit_monthly_fall_behind_msg: 'Monthly limit can\'t fall behind 0',
  limit_annual_fall_behind_msg: 'Annual limit can\'t fall behind 0',
  limit_monthly_exceed_msg: 'Monthly limit can\'t exceed annual out limit',
  limit_weekly_exceed_msg: 'Weekly limit can\'t exceed monthly out limit',
  limit_daily_exceed_msg: 'Daily limit can\'t exceed weekly out limit',
  lim_transaction_type: 'Transaction type',
  lim_requirements: 'Requirements',
  lim_withdrawal_daily_msg1: 'Attention! The transaction amount cannot exceed %{limit} %{asset}.',
  lim_withdrawal_daily_msg2: 'The total daily amount (banking day) cannot exceed %{limit} %{asset}.',
  lim_withdrawal_daily_msg3: 'Holidays and weekends are considered as a one banking day with further working day.'
}



// WEBPACK FOOTER //
// ./src/js/i18n/views/limits_view.js